
import React, {useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {getDeliveryPercentList, getGoogleSheet, getSymbolList } from "../action/api-services";
import StockAction from "../component/stockAction";
import moment from "moment";
import { useDispatch } from "react-redux";
import PageLoader from "../component/loader";
import DeliveryGraph from "../component/deliveryGraph";
import { useNavigate } from "react-router-dom";
import SectorPanchang from "../component/sectorPanchag";
import StockStrength from "../component/stockStrength";
import { isFarFromEMA20 } from "../utils/utilsFunctions";
import { setDeliveryDataReducer } from "../redux/slice/deliveryData";
import { calculateLeaderScore } from "../utils/constants";



const AllSymbolsPage = () => {
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(true);
    const [symbolData, setSymbolData] = useState([]);
    const [getGroupSectors, setGroupSectors] = useState([]);
    const [deliveryByDateData, setDeliveryByDateData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [prevFilteredData, setPrevFilteredData] = useState([]);
    const [todayData, setTodayData] = useState([]);
    const [searchKey, setSearchKey] = useState('');
    const [series, setSeries] = useState('EQ');
    const [sector, setSector] = useState('All');
    const [indices, setIndices] = useState('All');
    const [listingDate, setListingDate] = useState('All');
    const [getStocksPL, setStocksPL] = useState({});
    const NSE_Past_date = useSelector((state) => state.pastDate.value);
    // const [startDate, setStartDate] = useState(NSE_Past_date[0]?.max_date);
    const [startDate, setStartDate] = useState(new Date());
    const [currentSort, setCurrentSort] = useState(false);
    const [ROE, setROE] = useState('Select');
    const [ROECAGR, setROECAGR] = useState(15);    
    const [priceCAGR, setPriceCAGR] = useState('Select');
    const [priceValue, setPriceValue] = useState(15);
    const userToken = useSelector((state) => state.userToken.value);
    const navigate = useNavigate();
    const [todayTime, setTodayTime] = useState([]);
    const deliveryDataList = useSelector((state) => state.deliveryData.value);


    useEffect(() => {
        if (!userToken) {
            navigate(`/`);
            return;
        }

        const current_date = moment(startDate).format('DDMMYY');
        // dispatch(setDeliveryDateReducer(startDate));

        Promise.all([
            getSymbolList(series, 'All', userToken),
            getDeliveryPercentList('', 'symbols', '','', series, '', userToken),
            getGoogleSheet('', userToken)
        ])
            .then(([symbolRes, deliveryRes, sheetRes]) => {
            setSymbolData(symbolRes.data.data);
            setDeliveryByDateData(deliveryRes.data.data);
            dispatch(setDeliveryDataReducer(deliveryRes.data.data));
            setTodayTime(sheetRes.data.data.datetime);
            setTodayData(sheetRes.data.data.json_data);
            })
            .catch((err) => {
            console.log("Error", err);
            });

    }, [userToken, startDate, series]);

    useEffect(() =>{
        
        setLoader(true);
        if(symbolData?.length > 0 && todayData?.length > 0 && deliveryByDateData?.length > 0){
            
                if(ROE !== "Select"){

                }

                const uniqueSectors = [...new Set(
                    symbolData
                        .filter(item => item.series === series && item.group_sector && item.group_sector.trim() !== '')
                        .map(item => item.group_sector.trim())
                )].sort();
                setGroupSectors(uniqueSectors);

                const filtered = symbolData?.filter((obj) => {
                    return ( 
                        obj.series === series
                        && obj.active === '1'
                        && (ROE === "Select"?obj: 
                        ROE === 'ROE' && parseFloat(obj.ROE) > ROECAGR? obj:
                        ROE === 'roeCAGR_3Y' && parseFloat(obj.roeCAGR_3Y) > ROECAGR? obj:
                        ROE === 'roeCAGR_5Y' && parseFloat(obj.roeCAGR_5Y) > ROECAGR ? obj:
                        ROE === 'roeCAGR_10Y' && parseFloat(obj.roeCAGR_5Y) > ROECAGR ? obj:null)


                        && (priceCAGR === "Select"?obj: 
                        priceCAGR === 'priceCAGR_1Y' && parseFloat(obj.priceCAGR_1Y) > priceValue? obj:
                        priceCAGR === 'priceCAGR_3Y' && parseFloat(obj.priceCAGR_3Y) > priceValue? obj:
                        priceCAGR === 'priceCAGR_5Y' && parseFloat(obj.priceCAGR_5Y) > priceValue ? obj:
                        priceCAGR === 'priceCAGR_10Y' && parseFloat(obj.priceCAGR_10Y) > priceValue ? obj:null )
                      
                    );
                });
                
                let filterData = filtered.map(item => {
                        const today = todayData?.find(t => t.TICKER === item.symbol);
                        // const delivery = deliveryByDateData?.find(d => d.symbol === item.symbol);
                        let deliverylist = Object.values(deliveryDataList);
                        let delivery = deliverylist?.find((s) => s.symbol === item.symbol);

                        const scoreData = {
                            RSI: Number(delivery?.RSI || 0),
                            ATR_PER: Number(delivery?.ATR_PER || 0),
                            angle5: Number(delivery?.angle5 || 0),
                            angle10: Number(delivery?.angle10 || 0),
                            angle15: Number(delivery?.angle15 || 0),
                            delivery_per: Number(delivery?.stock_data?.[0]?.delivery_per || 0),
                            prev_delivery_per: Number(delivery?.stock_data?.[1]?.delivery_per || 0),
                            ttl_trd_qty: Number(delivery?.stock_data?.[0]?.ttl_trd_qty || 0),
                            prev_volume: Number(delivery?.stock_data?.[1]?.ttl_trd_qty || 0),
                            Turnover_per: Number(delivery?.Turnover_per || 0),
                            structure: delivery?.structure || '', 
                            structure_json:   delivery?.structure_json || ''
                        };

                        
                        let lastChild = delivery?.stock_data?.length - 1;


                        const aLTP = Number(today?.LTP);

                        const aClose1 = Number(delivery?.stock_data?.[0]?.close_price);
                        const aClose5 = Number(delivery?.stock_data?.[lastChild]?.close_price);
                        const aCurrLTP = !isNaN(aLTP) && aLTP > 0 ? aLTP : aClose1;
                        const aPL_per = ((aCurrLTP - aClose5) / aClose5) * 100;

                        // console.log(scoreData)
                        
                        return {
                        ...item,
                        delivery: delivery,
                        today: today,
                        PL_per:aPL_per,
                        score: calculateLeaderScore(scoreData)
                        };
                }).sort((a, b) => {
                    // const change_A = parseFloat(a.today?.CHANGEPER) || 0;
                    // const change_B = parseFloat(b.today?.CHANGEPER) || 0;
                    const change_A = Number(a?.score || 0);
                    const change_B = Number(b?.score || 0);
                    return change_B - change_A;
                });

                // console.log(filterData);
            
            setFilteredData(filterData);
            setPrevFilteredData(filterData);
            setLoader(false);
        }

    },[symbolData, todayData, series, sector, indices, listingDate, ROE, ROECAGR, priceCAGR, priceValue])
    



    const handleSearch = (e) =>{
        if(e.length >= 2 ){
            setSearchKey(e);
            const result = prevFilteredData.filter(item => item.symbol.toLowerCase().includes(e.toLowerCase()))
            setFilteredData(result);
        }else{
            setSearchKey('');
        }
        
    }

    const handleSeries = (e) => {
        setSeries(e);
        setSector('Áll');
        let sector = document.getElementById('sector');
        sector.selectedIndex = 0;
    }

    const handleSector = (e) => {
        if(e === "All"){
            setFilteredData(prevFilteredData)
        }else{
            let filtered = prevFilteredData.filter((obj) => obj.group_sector === e);
            setFilteredData(filtered);
        }
    }

    const handlerIndices = (e) =>{
        let indices = e;
        if(indices === "All"){
            setFilteredData(prevFilteredData)
        }else{
          
            let filtered = prevFilteredData.filter((obj) => {
                return(
                        indices === 'nifty50' && obj.nifty50 === 'Yes'? obj:
                        indices === 'nifty100' && obj.nifty100 === 'Yes'? obj:
                        indices === 'nifty200' && obj.nifty200 === 'Yes'? obj:
                        indices === 'nifty500' && obj.nifty500 === 'Yes'? obj:
                        indices === 'totalMarket' && obj.totalMarket === 'Yes'? obj:
                        indices === 'myFev' && obj.myFev === 'Yes'? obj:
                        indices === 'hotStar' && obj.hotStar === '1'? obj:null
                )   
            });     
            setFilteredData(filtered);
        }        
    }
    

    const dataSortBy = (filterType, sortby) => {
        let currentSort = sortby;
        setCurrentSort(sortby);
        //  console.log("?????", filterType, currentSort)
        const sortedData = [...filteredData];
        if(filterType === "sector"){
             if(currentSort === true){
                sortedData.sort((a, b) => {
                    if (a.series === "ETF" && b.series !== "ETF") return -1;
                    if (a.series !== "ETF" && b.series === "ETF") return 1;
                    return a.group_sector.localeCompare(b.group_sector); // Sorting alphabetically by sector
                });
             }else{
                sortedData.sort((a, b) => {
                    if (a.series === "ETF" && b.series !== "ETF") return -1;
                    if (a.series !== "ETF" && b.series === "ETF") return 1;
                    return b.group_sector.localeCompare(a.group_sector); // Sorting alphabetically by sector
                });
             }
        }

        else if(filterType === "change"){
            if(currentSort === true){
                sortedData.sort((a, b) => {
                    let change_A = todayData.find(item => item.TICKER === a.symbol)?.CHANGEPER || 0;
                    let change_B = todayData.find(item => item.TICKER === b.symbol)?.CHANGEPER || 0;               
                    return change_B - change_A;
                });
            }else{
                    sortedData.sort((a, b) => {
                    let change_A = todayData.find(item => item.TICKER === a.symbol)?.CHANGEPER || 0;
                    let change_B = todayData.find(item => item.TICKER === b.symbol)?.CHANGEPER || 0;               
                    return change_A - change_B;
                });
            }
            
        }


        else if(filterType === "down_now"){
            if(currentSort === true){
                sortedData.sort((a, b) => {
                    let close_price_A = deliveryByDateData.find(item => item.symbol === a.symbol)?.close_price || 0;
                    let close_price_B = deliveryByDateData.find(item => item.symbol === b.symbol)?.close_price || 0;
                
                    let percentageA = close_price_A ? ((a.high52w - close_price_A) * 100) / a.high52w : 0;
                    let percentageB = close_price_B ? ((b.high52w - close_price_B) * 100) / b.high52w : 0;
                
                    return percentageA - percentageB;
                });
            }else{
                sortedData.sort((a, b) => {
                    let close_price_A = deliveryByDateData.find(item => item.symbol === a.symbol)?.close_price || 0;
                    let close_price_B = deliveryByDateData.find(item => item.symbol === b.symbol)?.close_price || 0;
                
                    let percentageA = close_price_A ? ((a.high52w - close_price_A) * 100) / a.high52w : 0;
                    let percentageB = close_price_B ? ((b.high52w - close_price_B) * 100) / b.high52w : 0;
                
                    return percentageB - percentageA;
                });
            }
        }
        
        
        else if(filterType === "low52"){
            sortedData.sort((a, b) => new Date(a.lowDate) - new Date(b.lowDate));
        }
        else if(filterType === "listing"){
            sortedData.sort((a, b) => new Date(a.listingDate) - new Date(b.listingDate));
        }

        else if(filterType === "volume"){
            sortedData.sort((a, b) => {
                let change_A =  a.delivery?.stock_data[0]?.ttl_trd_qty  || 0;
                let change_B =  a.delivery?.stock_data[1]?.ttl_trd_qty  || 0;
                if(currentSort === true){
                    return change_B - change_A;
                }else{
                    return change_A - change_B;
                }
            });
            
        }

        else if(filterType === "delivery"){
            sortedData.sort((a, b) => {
                let change_A =  a.delivery?.stock_data[0]?.delivery_per  || 0;
                let change_B =  a.delivery?.stock_data[1]?.delivery_per  || 0;
                if(currentSort === true){
                    return change_B - change_A;
                }else{
                    return change_A - change_B;
                }
            });
            
        }


        else if(filterType === "emaDist"){
            sortedData.sort((a, b) => {
                let change_A =  isFarFromEMA20(a.today?.LTP, a?.delivery?.EMA20)['ema_distance'];
                let change_B =  isFarFromEMA20(b.today?.LTP, b?.delivery?.EMA20)['ema_distance'];
                if(currentSort === true){
                    return change_A - change_B;
                }else{
                    return change_B - change_A;
                }
            });
            
        }
        

        else if (filterType === "CHN5"){
                sortedData.sort((a, b) => {
                    const aPL = a.PL_per;
                    const bPL = b.PL_per;

                    return currentSort
                        ? aPL - bPL   // Low → High
                        : bPL - aPL;   // High → Low
                });
                                        
        }else if (filterType === "strength"){
                const rows = document.querySelectorAll('table tbody tr');

                const scoreMap = {};

                rows.forEach((row) => {
                const id = row.id?.replace("row_item_", "");
                const strength = row.querySelector('.strength_count')?.textContent?.trim();

                const score = strength ? parseInt(strength.split('/')[0], 10) : 0;

                if (id) {
                    scoreMap[id] = score;
                }
                });
                // console.log("Score Map:", scoreMap);

                sortedData.sort((a, b) => {
                const scoreA = scoreMap[a.id] || 0;
                const scoreB = scoreMap[b.id] || 0;

                return currentSort
                    ? scoreB - scoreA   // DESC
                    : scoreA - scoreB;  // ASC
                });

        }
        else if (filterType === "score"){

             if(currentSort === true){
                sortedData.sort((a, b) => {
                    return b.score - a.score; // Sorting alphabetically by setup
                });
              }else{
                sortedData.sort((a, b) => {
                    return a.score - b.score; // Sorting alphabetically by setup
                });
              }
        }

        else{          
            // console.log("filterType>>>", filterType);  
            if(currentSort === true){
                sortedData.sort((a, b) => b[filterType] - a[filterType]);
            }else{
                sortedData.sort((a, b) => a[filterType] - b[filterType]);
            }
        }

        
        
        // console.log("Sorting by:", filterType, sortedData);

        // sortedData.sort((a, b) => new Date(a.deg) - new Date(b.deg));
        

        setFilteredData(sortedData);
      };
    
      useEffect(() =>{
        let gain = 0;
        let loss = 0;
        filteredData.map((item) =>{
            const symbolName = item.symbol;
            let filterData = todayData.filter((item, index) => item.TICKER === symbolName);
   

            if(filterData[0]?.CHANGEPER > 0){
                gain = gain+1;
            }else{
                loss = loss+1;
            }
        });
        
        let meta = {
            "gain": gain,
            "loss": loss,
            "total": filteredData.length
        }
        setStocksPL(meta);


      }, [filteredData])

return (
    <React.Fragment>
        <div className="pageContainer">
        {
            (loader === true? <PageLoader />: 
            <React.Fragment>
                <div className="container-fluid actionControler py-3">
                        <div className="row">
                            <div className="col">
                                <div className="form-floating">
                                    <input type="text" className="form-control" id="symbolSearch" placeholder="Search" onKeyUp={(e) => handleSearch(e.target.value)} />
                                    <label htmlFor="symbolSearch">Search</label>
                                </div>
                            </div>
                            
                            <div className="col">
                                <div className="form-floating">
                                    <select className="form-control" id="series" defaultValue={series} onChange={(e) => handleSeries(e.target.value)}>
                                        <option value="EQ" key={`series_EQ`}>EQ</option>
                                        <option value="ETF" key={`series_ETF`}>ETF</option>
                                        {/* <option value="BOND" key={`series_Bond`}>BOND</option> */}
                                    </select>
                                    <label htmlFor="series">Series</label>
                                </div>
                            </div>

                            <div className="col">
                                <div className="form-floating">
                                    <select className="form-control" id="sector" defaultValue={sector} onChange={(e) =>  handleSector(e.target.value)}>
                                        <option value="All" key={0}>All</option>
                                        {getGroupSectors?.map((item, index) => {
                                                return (<option key={index+1} value={item}>{item}</option>)
                                            })
                                        }
                                    </select>
                                    <label htmlFor="sector">Sector</label>
                                </div>
                            </div>

                            <div className="col">
                                <div className="form-floating">
                                    <select className="form-control" id="indices" defaultValue={series} onChange={(e) => handlerIndices(e.target.value)}>
                                        <option value="All" key={`indices_all`}>All</option>
                                        <option value="nifty50" key={`indices_nifty50`}>Nifty 50</option>
                                        <option value="nifty100" key={`indices_nifty100`}>Nifty 100</option>
                                        <option value="nifty200" key={`indices_nifty200`}>Nifty 200</option>
                                        <option value="nifty500" key={`indices_nifty500`}>Nifty 500</option>
                                        <option value="totalMarket" key={`indices_total_market`}>Total Market</option>
                                        <option value="myFev" key={`indices_fev`}>Fev</option>
                                        <option value="hotStar" key={`indices_indices`}>Hot Stars</option>
                                    </select>
                                    <label htmlFor="indices">Indices</label>
                                </div>
                            </div>


                            <div className="col">
                                <div className="form-floating">
                                    <select className="form-control" id="roecagr" defaultValue={ROE} onChange={(e) => setROE(e.target.value)}>
                                        <option value="Select" key={`roecarg`}>Select</option>
                                        <option value="ROE" key={`roe1y`}>ROE 1Y</option>
                                        <option value="roeCAGR_3Y" key={`roe3y`}>ROE 3Y</option>
                                        <option value="roeCAGR_5Y" key={`roe5y`}>ROE 5Y</option>
                                        <option value="roeCAGR_10Y" key={`roe10y`}>ROE 10Y</option>
                                    </select>
                                    <label htmlFor="roecagr">ROE Type</label>
                                </div>
                            </div>
                            {ROE !== 'Select'?
                            <div className="col">
                                <div className="form-floating">
                                    <input type="text" className="form-control" id="roecagr" placeholder="ROE CAGR%" defaultValue={ROECAGR} onKeyUp={(e) => setROECAGR(e.target.value)} />
                                    <label htmlFor="roecagr">ROE CAGR%</label>
                                </div>
                            </div>
                            :''}

                            <div className="col">
                                <div className="form-floating">
                                    <select className="form-control" id="pricecagr" defaultValue={priceCAGR} onChange={(e) => setPriceCAGR(e.target.value)}>
                                        <option value="Select" key={`pricecagr_select`}>Select</option>
                                        <option value="priceCAGR_1Y" key={`pricecagr_price1y`}>Price 1Y</option>
                                        <option value="priceCAGR_3Y"  key={`pricecagr_price3y`}>Price 3Y</option>
                                        <option value="priceCAGR_5Y"  key={`pricecagr_price5y`}>Price 5Y</option>
                                        <option value="priceCAGR_10Y"  key={`pricecagr_price10y`}>Price 10Y</option>
                                    </select>
                                    <label htmlFor="pricecagr">Price in Year</label>
                                </div>
                            </div>

                            {priceCAGR !== 'Select'?
                            <div className="col">
                                <div className="form-floating">
                                    <input type="text" className="form-control" id="setpricevalue" placeholder="Price CAGR%" defaultValue={priceValue} onKeyUp={(e) => setPriceValue(e.target.value)} />
                                    <label htmlFor="setpricevalue">Price CAGR%</label>
                                </div>
                            </div>
                            :''}

                            {/* <div className="col">
                                <div className="form-floating">
                                    <select className="form-control" id="listingDate" defaultValue={series} onChange={(e) => setListingDate(e.target.value)}>
                                        <option value="All">All</option>
                                        <option value="1year">1 Year</option>
                                        <option value="2years">2 Years</option>
                                        <option value="3years">3 Years</option>
                                        <option value="4years">4 Years</option>
                                        <option value="5years">5 Years</option>
                                        <option value="10years">10 Years</option>
                                    </select>
                                    <label htmlFor="listingDate">Listing Date</label>
                                </div>
                            </div> */}
                            
                        </div>
                </div>
                <div className="pagewrap">
                <table className="table table-bordered frozen-table symbolList" style={{width:'2550px'}}>
                    <thead>
                        <tr>
                            <th style={{width:'170px'}}>Symbol [<span style={{color: '#1c8b16'}}>{getStocksPL?.gain}</span>/<span style={{color: '#f00'}}>{getStocksPL?.loss}</span>|{getStocksPL?.total}]</th>
                            <th style={{minWidth:'40px'}}></th>
                            <th style={{minWidth:'10px'}}></th>
                            <th style={{width:'85px' , textAlign:'left'}}>Strength <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('strength', !currentSort)}}></button></th>
                            <th style={{width:'65px', textAlign:'left'}}>Score <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('score', !currentSort)}}></button></th>
                            <th style={{width:'45px', textAlign:'left'}}>Series</th>
                            <th style={{width:'160px', textAlign:'left'}}>Sector <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('sector', !currentSort)}}></button></th>
                            <th style={{width:'160px', textAlign:'left'}}>Industry</th>
                            <th style={{width:'60px', textAlign:'left'}}>Indices</th>
                            <th style={{width:'140px'}} colSpan={2}>LTP | Chn% [{moment(todayTime).format('HH:mm')}] <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('change', !currentSort)}}></button></th>
                            <th style={{width:'90px'}}>EMA Dist <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('emaDist', !currentSort)}}></button></th>
                            <th style={{width:'90px'}}>5D Chn%<button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('CHN5', !currentSort)}}></button></th>
                            <th style={{width:'60px'}}>SMA200</th>
                            <th style={{width:'90px'}}>52 Down <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('down_now', !currentSort)}}></button></th>
                            <th style={{width:'120px'}}>52 High <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('high52', !currentSort)}}></button></th>
                            <th style={{width:'120px'}}>52 Low <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('low52', !currentSort)}}></button></th>
                            <th style={{width:'80px'}}>Volume <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('volume', !currentSort)}}></button></th>
                            <th style={{width:'65px'}}>Del% <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('delivery', !currentSort)}}></button></th>
                            <th style={{width:'85px'}} title="Price CAGR%">P CAGR <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy(priceCAGR, !currentSort)}}></button></th>
                            <th style={{width:'65px'}}>ROE <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy(ROE, !currentSort)}}></button></th>
                            <th style={{width:'70px'}}>ROCE <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('ROCE', !currentSort)}}></button></th>
                            <th style={{width:'65px'}}>PE <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('PE', !currentSort)}}></button></th>
                            <th style={{width:'65px'}}>EPS <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('EPS', !currentSort)}}></button></th>                            
                            <th style={{width:'100px'}}>MarketCap <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('MarketCap', !currentSort)}}></button></th>
                            <th style={{width:'90px'}}>Promoter <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('Promoter_holding', !currentSort)}}></button></th>
                            <th style={{width:'60px'}}>FII <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('FII_holding', !currentSort)}}></button></th>
                            <th style={{width:'60px'}}>DII <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('DII_holding', !currentSort)}}></button></th>
                            <th style={{width:'110px'}}>Government <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('Government_holding', !currentSort)}}></button></th>                            
                            <th style={{width:'auto'}}>Events</th>
                        </tr>
                    </thead>
                    <tbody>
                    
                    {filteredData?.map((item, index)=>{
                        // console.log(item)
                        const symbolName = item.symbol;
                        let prevVolume = (((parseInt(item?.delivery?.stock_data[0]?.ttl_trd_qty) - parseInt(item?.delivery?.stock_data[1]?.ttl_trd_qty)) * 100)/parseInt(item?.delivery?.stock_data[1]?.ttl_trd_qty)).toFixed(2);
                        return(
                            <>
                                <tr className={`tr_${item.id}`} key={item.id} id={`row_item_${item.id}`}>
                                    <td 
                                        className={`symbolName  ${item.in_watchlist ==='1'? 'inwatchlist':''}`}>
                                        {symbolName} 
                                        {item.hotStar === '1'? <span className="hotStar"></span>:null}
                                        {item?.delivery?.current_star === "1" ? <span className="currStar"></span> : null}
                                    </td>
                                    <td style={{padding: '5px 0px 0px 0px', textAlign: 'center'}}><DeliveryGraph symbol={symbolName} todayLTP={item.today} date={moment(NSE_Past_date[0]?.max_date).format('YYYY-MM-DD')}/></td>
                                    <td style={{width: '10px', padding: '0px', textAlign: 'center'}}>                                        
                                        <StockAction 
                                            symbol={symbolName} 
                                            delivery={false} 
                                            currentPrice ={item.today?.LTP} 
                                            deliveryPer={item?.delivery?.stock_data[0]?.delivery_per} 
                                            hotStar={item.hotStar} 
                                            myFev={item.myFev} 
                                            eventName = "Symbol"
                                            slPrice={(item.today?.LTP ?? 0) * 0.98}
                                            gttPrice={(item.today?.LTP ?? 0) * 1.03}
                                            rowId={`row_item_${item.id}`}
                                            score = {item.score}
                                            />
                                    </td>
                                    {
                                        (item.today)?
                                            <StockStrength id= {`s_${item.id}`} selectedDate={startDate} symbol={symbolName} todayLTP={item.today} details={item} />
                                    : <td>&nbsp;</td>
                                    }
                                    <td style={{textAlign:'left'}}>{item.score} </td>
                                    <td style={{textAlign:'left'}}>{item.series} </td>
                                    
                                    {/* <td style={{textAlign:'left', lineHeight:'1.1'}}>{item.group_sector}</td> */}
                                    <SectorPanchang symbol={symbolName} sector={item.group_sector} todayData={todayData} symbolData={symbolData} tag = "td" align = "right" durationDays = "" />
                                    <td style={{textAlign:'left', lineHeight:'1.1'}}>{item.industry}</td>
                                    <td className="indices" style={{ textAlign: 'left' }}>
                                        {(() => {
                                                const label = item.nifty50? '50': item.nifty100? '100': item.nifty200? '200': item.nifty500? '500': item.totalMarket? 'TM': '';
                                                const excludedSeries = ['ETF', 'BOND', 'MF'];
                                                const showFev = item.myFev && !excludedSeries.includes(item.series);
                                                return label + (showFev ? `${label ? ', ' : ''}Fev` : '');
                                        })()}
                                    </td>

                                    <td style={{width: '65px', textAlign: 'right'}}>{item.today?.LTP}</td>
                                    <td style={{width: '65px', textAlign: 'right',  color: item.today?.CHANGEPER > 0 ? '#1c8b16' : '#f00'}}>{item.today?.CHANGEPER}%</td>
                                    <td style={{textAlign:'right'}} title={`${item?.delivery?.EMA20}`}>
                                        {isFarFromEMA20(item.today?.LTP, item?.delivery?.EMA20)['ema_distance']}%
                                    </td>
                                    <td style={{textAlign:'right'}}>{item.PL_per.toFixed(2)}%</td>
                                    <td style={{textAlign:'right', background: parseFloat(item?.delivery?.SMA50) > parseFloat(item?.delivery?.SMA200)? "#e2ffe5":"#fff8f8" }} title={`SMA50: ${item?.delivery?.SMA50}`}>{item?.delivery?.SMA200}</td>
                                    <td style={{textAlign:'right'}}>{item.today?.LTP? ((item.high52w - item.today?.LTP)*100/item.high52w).toFixed(2): ''}</td>
                                    <td style={{textAlign:'right'}}>{item.high52w} | {moment(item.highDate).format('DD/MM/YY')}</td>
                                    <td style={{textAlign:'right'}}>{item.low52w} | {moment(item.lowDate).format('DD/MM/YY')}</td>                                    
                                    <td style={{textAlign:'right'}}
                                        className={prevVolume > 100? "datrcolor" : ""}
                                        title={`${prevVolume}%`}
                                        >
                                        {Number(item?.delivery?.stock_data[0].ttl_trd_qty).toLocaleString("en-IN") }
                                    </td>
                                    <td style={{textAlign:'right'}}
                                        className={item?.delivery?.stock_data[0]?.delivery_per > item?.delivery?.stock_data[1]?.delivery_per? "datrcolor" : ""}
                                        title={item?.delivery?.stock_data[1]?.delivery_per}>
                                        {item?.delivery?.stock_data[0]?.delivery_per}%
                                    </td>
                                    <td style={{textAlign:'right'}}>{priceCAGR === 'priceCAGR_10Y'? item.priceCAGR_10Y: priceCAGR === 'priceCAGR_5Y'? item.priceCAGR_5Y: priceCAGR === 'priceCAGR_3Y'? item.priceCAGR_3Y:item.priceCAGR_1Y}</td>
                                    <td style={{textAlign:'right'}}>{ROE === 'roeCAGR_10Y'? item.roeCAGR_10Y: ROE === 'roeCAGR_5Y'? item.roeCAGR_5Y:ROE === 'roeCAGR_3Y'? item.roeCAGR_3Y:item.ROE}</td>
                                    <td style={{textAlign:'right'}}>{item.ROCE}</td>
                                    <td style={{textAlign:'right'}}>{item.PE}</td>
                                    <td style={{textAlign:'right'}}>{item.EPS}</td>                                    
                                    <td style={{textAlign:'right'}}>{item.MarketCap}</td>
                                    <td style={{textAlign:'right'}}>{item.Promoter_holding}</td>
                                    <td style={{textAlign:'right'}}>{item.FII_holding}</td>
                                    <td style={{textAlign:'right'}}>{item.DII_holding}</td>
                                    <td style={{textAlign:'right'}}>{item.Government_holding}</td>
                                    <td style={{textAlign:'left'}}>{item.events}</td>
                                </tr>                                
                            </>
                        ) 
                        
                    })
                    
                    }
                    </tbody>
                </table>
                </div>
            </React.Fragment>
            )
        }
        </div>
    </React.Fragment>
)

}
export default AllSymbolsPage;